import { ConfigProvider, Flex, Segmented } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Kalender / Daftar segmented pill (prototype .seg): bg-soft track, the
// selected option as a white pill with ink text + subtle shadow, unselected
// options in muted ink. Text-only — no icons. A styled switch over the
// existing /schedule and /list routes — routing logic is unchanged: it just
// navigates between the two routes and reflects the active one from the
// current path.
export const ScheduleViewToggle = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const value = pathname === PATHS.LIST ? PATHS.LIST : PATHS.SCHEDULE;

  // The active option is semibold.
  const segLabel = (text: string, selected: boolean) => (
    <Flex
      align="center"
      justify="center"
      style={{
        padding: "4px 6px",
        fontSize: textPx(13),
        fontWeight: selected ? 600 : 500,
      }}
    >
      {text}
    </Flex>
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            trackBg: colors.bgSoft,
            trackPadding: 3,
            itemColor: colors.ink2,
            itemHoverColor: colors.ink,
            itemHoverBg: "transparent",
            itemSelectedBg: colors.card,
            itemSelectedColor: colors.ink,
            borderRadius: 999,
            borderRadiusSM: 999,
            borderRadiusLG: 999,
          },
        },
        // The selected pill's shadow (AntD applies boxShadowTertiary to it).
        token: { boxShadowTertiary: "0 1px 2px rgba(15, 15, 14, 0.08)" },
      }}
    >
      <Segmented
        value={value}
        // Carry the query along (?date=...) so toggling Kalender → Daftar →
        // Kalender keeps the viewed week; Daftar just ignores it.
        onChange={(val) => navigate({ pathname: val as string, search })}
        options={[
          {
            value: PATHS.SCHEDULE,
            label: segLabel(
              translate("schedule.calendar"),
              value === PATHS.SCHEDULE
            ),
          },
          {
            value: PATHS.LIST,
            label: segLabel(translate("schedule.list"), value === PATHS.LIST),
          },
        ]}
      />
    </ConfigProvider>
  );
};
